module.exports = __webpack_public_path__ + "static/img/float-service.a933191.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/float-service.png
// module id = KLlf
// module chunks = 3